module.exports = __webpack_public_path__ + "media/svg/tick-9e1c24d8.svg";